import Cookies from 'js-cookie';
import { ONE_YEAR } from 'constants/time';
import { SESSION_INFO_API } from 'constants/routes';
import { PODCASTER_SESSION_ID, SESSION_ID } from 'constants/cookies';
import { call } from 'redux-saga/effects';
import { postWithCredentials } from '../api';

export function* updateSession(): any {
  let sessionId = Cookies.get(SESSION_ID);

  const oneYearFromNow = Date.now() + ONE_YEAR;

  if (!sessionId) {
    const response = yield call(postWithCredentials, {
      body: {},
      path: SESSION_INFO_API,
    });

    if (response.ok) {
      const json = yield call([response, 'json']);
      sessionId = json.sessionId;
      if (sessionId) {
        yield Cookies.set(SESSION_ID, sessionId, {
          domain: '.amazon.com',
          expires: new Date(oneYearFromNow),
          secure: true,
        });
      }
    }
  }

  const podcasterSessionId = Cookies.get(PODCASTER_SESSION_ID);

  if (!podcasterSessionId && sessionId) {
    yield Cookies.set(PODCASTER_SESSION_ID, sessionId, {
      expires: new Date(oneYearFromNow),
      secure: true,
    });
  }
}
